import React from 'react';
import Amplify from 'aws-amplify';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { getAllSettlement } from '../../../Actions/actions';
import SubuserListAffiliate from './subuserListAffiliate';
import logo from '../../../images/logo.png';
import * as SecretKeys from '../../../ENV.json';
import SideMenu from '../../sideMenu/sideMenu';

Amplify.configure(SecretKeys.awsUserpool);
const userid = localStorage.getItem('userId');

class SubuserListAffiliateContainer extends React.Component {
  componentWillMount() {
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState || this.props !== nextProps) {
      // this.forceUpdate();
      return true;
    }
    return false;
  }

  saveEnrichmentAnswer(queId, ans) {
    const data = { userId: userid, value: ans, enrichmentQuestionId: queId };
    this.props.saveEnrichmentAnswer(data);
  }

  render() {
    // const {} = this.state;

    return (
      <span>
        <SideMenu />
        <div className="container">
          <span>
            <header className="section">
              <div className="row">
                <div className="col s3">
                  <div className="logo dash-logo">
                    <Link to="/">
                      <img className="responsive-img" src={logo} alt="" />

                    </Link>
                  </div>
                </div>
              </div>
            </header>
          </span>
          <div className="main-content bg-grey">
            <SubuserListAffiliate />
          </div>
        </div>
      </span>
    );
  }
}

SubuserListAffiliateContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllSettlement }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubuserListAffiliateContainer));
